<template>
    <div class="news1">
        <div class="News-wrap">
            <h3>专业游艇码头制造商<br>Professional Floating Dock Manufacturer</h3>
           
        </div>

        <div class="navigation-wrap">

            <div class="navigation-bar">
                <div class="navigation-left-bar">
                    <p>您的位置：</p>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/News' }">新闻资讯</el-breadcrumb-item>
                        <el-breadcrumb-item>{{ news ? news.tag : "新闻详情" }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>

        </div>

        <div class="news_content">
            <div class="news_content_box">
                                <div class="content_title">
                    <h3>{{ news ? news.title : "新闻详情" }}</h3>
                </div>
                <div class="content_date">
                    <p>发布时间：{{ news ? news.date : "" }}</p>
                    <span>新闻标签：{{ news ? news.tag : "" }}</span>
                </div>
            </div>

                        <div class="news_content_text">
                <img v-if="coverUrl" :src="coverUrl" alt="">
                <p v-for="(para, idx) in paragraphs" :key="idx">{{ para }}</p>
                <p v-if="!loading && paragraphs.length === 0">暂无内容</p>
            </div>

            <div class="content_page">
                <router-link v-if="prev" :to="'/n1?id=' + prev.id" class="last_page">上一篇：{{ prev.title }}</router-link>
                <span v-else class="last_page">上一篇：没有了</span>
                <router-link v-if="next" :to="'/n1?id=' + next.id" class="next_page">下一篇：{{ next.title }}</router-link>
                <span v-else class="next_page">下一篇：没有了</span>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewsList, getNewsDetail, assetUrl } from "../api/index"

export default {
    data() {
        return {
            news: null,
            neighbours: [],
            loading: true
        }
    },
    computed: {
        coverUrl() {
            return this.news && this.news.cover ? assetUrl(this.news.cover) : ""
        },
        paragraphs() {
            if (!this.news || !this.news.content) return []
            return String(this.news.content).split(/\r?\n\s*\r?\n/).map(s => s.trim()).filter(Boolean)
        },
        prev() {
            const i = this.neighbours.findIndex(n => String(n.id) === String(this.news && this.news.id))
            return i > 0 ? this.neighbours[i - 1] : null
        },
        next() {
            const i = this.neighbours.findIndex(n => String(n.id) === String(this.news && this.news.id))
            return i > -1 && i < this.neighbours.length - 1 ? this.neighbours[i + 1] : null
        }
    },
    methods: {
        load() {
            this.loading = true
            const id = this.$route.query.id
            getNewsDetail(id).then(res => {
                const payload = (res.data && res.data.data) || {}
                const list = payload.list || []
                this.news = list[0] || null
            }).catch(() => {
                this.news = null
            }).then(() => {
                this.loading = false
            })
            getNewsList().then(res => {
                const payload = (res.data && res.data.data) || {}
                this.neighbours = payload.list || []
            }).catch(() => {})
        }
    },
    watch: {
        "$route"() {
            this.load()
            window.scrollTo(0, 0)
        }
    },
    mounted() {
        this.load()
    }
}
</script>


<style>
   .news_content_text img{
       width: 800px;
   }

    @media screen and (max-width:768px) {
        .news_content{
            margin: 15px;
        }

        .news_content_text img{
            width: 100%;
            height: 100%;
        }
    }
</style>